//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LeftMenu',
  props: {
    miniVariant: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      clipped: true,
      drawer: false,
    }
  },
  methods: {
    isValidSource(cssClass) {
      try {
        require(`~/assets/icons/${cssClass}.png`);
        return true;
      } catch (error) {
        return false;
      }
    }
  },
  computed: {
    minimize: {
      get() {
        return this.miniVariant
      },
    },
    menuItems() {
      return this.$auth.user.menuItems
    },
  },
}
